// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__33ndU","log":"ModalInventoryLogs_log__3ORnk","date":"ModalInventoryLogs_date__butIm","userName":"ModalInventoryLogs_userName__FrgDf"};